import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { EnumUserRole } from 'lib/graphql';
import { BaseModule } from 'lib/modules';

// Lazy-loaded page components
const ProcessorBenchmarksPage = lazy(() =>
  import(
    /* webpackChunkName: "processor-benchmarks" */ 'features/reporting/pages/benchmarks/benchmarks-page'
  ).then((m) => ({ default: m.ProcessorBenchmarksPage })),
);

/**
 * Peer Benchmarks Module Implementation
 *
 * Split out of REPORTING so it can be rolled out to processors independently
 * of the rest of the reporting suite.
 */
class PeerBenchmarksModuleClass extends BaseModule {
  id = 'PEER_BENCHMARKS';
  name = 'Peer Benchmarks';
  label = 'Peer Benchmarks';
  description = 'Anonymized peer benchmarking for processors';
  version = '1.0.0';
  /**
   * Creates route objects for the Peer Benchmarks module
   * @param ProtectedRoute
   * @param LazyWrapper
   * @param settings
   * @param ModuleProtectedRoute
   */
  createRoutes = (
    ProtectedRoute: any,
    LazyWrapper: any,
    settings?: any,
    ModuleProtectedRoute?: any,
  ): RouteObject[] => {
    const routes: RouteObject[] = [];
    const RouteProtector = ModuleProtectedRoute || ProtectedRoute;

    routes.push({
      path: '/processor/benchmarks',
      element: (
        <RouteProtector
          component={ProcessorBenchmarksPage}
          moduleId="PEER_BENCHMARKS"
          allowedUserRoles={[EnumUserRole.VendorOwner, EnumUserRole.Admin]}
        />
      ),
    });

    return routes;
  };
}

// Export singleton instance
export const PeerBenchmarksModule = new PeerBenchmarksModuleClass();
